module.exports = __webpack_public_path__ + "media/icons/warning-icon-b91bf6bd.svg";